module.exports = Promise.resolve(module.bundle.root("eE83j"))